import zhImg from './assets/zh.png'
import enImg from './assets/en.png'
import { Language } from '@/hooks/lang/constant'

// 國旗圖示對應表
export const languageIconMap = new Map<Language, string>([
  [Language.EN, enImg],
  [Language.ZH, zhImg],
])
